import React from "react";
import { Typography, Grid, Tooltip } from "@mui/material";
import FacilityIssuesCard from "./facilityIssuesCard.component";
import TwoLineCard from "../twoLineCard.component";
import { FacilityStyles } from "../../styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import moment from "moment";
import { useSelector } from "react-redux";
import { selectOrganisationId } from "../../selectors/login.selector";
import { getClientStatus } from "../../utils/lib";

const FacilityAuditScheduling = ({ selectedFactory }) => {
  const orgId = useSelector(selectOrganisationId);
  const clientStatus = getClientStatus(orgId);
    
  const formatDate = (dateStr) => {
    if (dateStr === "N/A") return "N/A";
    return moment(dateStr).format("MM/DD/YY");
  };
  const isInactive = selectedFactory?.metadata?.status === "inactive";
  const auditDueData = {
    nextAuditDueDate: formatDate(
      selectedFactory?.auditCadence?.nextAuditDate || "N/A"
    ),
    isPastDue: moment(selectedFactory?.auditCadence?.nextAuditDate).isBefore(moment(), 'day')
  };
  const nextConfirmedAuditDate = formatDate(selectedFactory?.metadata?.confirmedNextAuditDate || "N/A");
  const lastAuditDate = selectedFactory?.latestAudit?.metadata?.facilityData?.audit_end
    ? moment(selectedFactory.latestAudit.metadata.facilityData.audit_end).format("MMM. DD, YYYY")
    : "N/A";

  console.log(selectedFactory, "selectedFactory")
    
  return (
    <>
      <Typography sx={FacilityStyles.mostRecentAuditHeading}>
        Audit Scheduling
        <Tooltip 
          title={
            <React.Fragment>
              • Next Audit Due Date: Set by {clientStatus.clientName || "the client"} according to the audit scheduling cadence.
              <br />
              <br />
              • Upcoming Scheduled Audit Date: Submitted by the supplier after scheduling the next audit. This can be updated in the Quick Action section on the top of this page.
            </React.Fragment>
          }
          placement="right"
        >
          <InfoOutlinedIcon
            sx={{ marginLeft: "8px", color: "#A0A5AD", verticalAlign: "middle" }}
          />
        </Tooltip>
      </Typography>
      <Grid container spacing={4}>
      <Grid item xs={4}>
        <TwoLineCard
            title="Last Audit Date"
            nextAuditDate={lastAuditDate}
          />
        </Grid>
        <Grid item xs={4}>
        <TwoLineCard
            title="Next Audit Due Date"
            nextAuditDate={
              auditDueData?.nextAuditDueDate || "N/A"
            }
            textColor={
              !isInactive && auditDueData?.isPastDue ? "#B42318" : "inherit"
            }
          />
        </Grid>
        <Grid item xs={4}>
          <TwoLineCard
            title="Upcoming Scheduled Audit Date"
            nextAuditDate={nextConfirmedAuditDate}
          />
        </Grid>
      </Grid>
    </>
  );
};
export default FacilityAuditScheduling;